import axios from "axios";
import DOMPurify from "dompurify";

export const baseUrl = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}`;

export function mergeObjectsFromArray(arr) {
  return arr.reduce(function (result, obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        result[key] = obj[key];
      }
    }
    return result;
  }, {});
}

export function extractProperties(firstObject, secondObject) {
  const result = {};
  for (const key in secondObject) {
    if (firstObject.hasOwnProperty(key)) {
      result[key] = firstObject[key];
    }
  }
  return result;
}

export function getNewProperties(firstObject, secondObject) {
  const result = {};
  for (const key in firstObject) {
    if (!secondObject.hasOwnProperty(key)) {
      result[key] = firstObject[key];
    }
  }
  return result;
}

export async function refreshTokenHandler() {
  try {
    const refreshTokenResponse = await axios.post(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/auth/tokens:refresh`,
      null,
      {
        withCredentials: true,
      }
    );
    return refreshTokenResponse.data;
  } catch (refreshError) {
    console.error("Error refreshing token:", refreshError);
  }
}

export function base64ToFile(base64Data, fileName, fileType) {
  if (!base64Data || typeof base64Data.content !== "string") {
    throw new Error(
      "Invalid base64 input: content is missing or not a string."
    );
  }

  const base64StringParts = base64Data.content.split(",");

  if (base64StringParts.length !== 2) {
    throw new Error(
      "Invalid base64 format. Expecting 'data:[mime];base64,...'"
    );
  }

  const base64String = base64StringParts[1];
  let byteString;
  try {
    byteString = atob(base64String);
  } catch (e) {
    throw new Error("Failed to decode base64: " + e.message);
  }

  const arrayBuffer = new ArrayBuffer(byteString.length);
  const uint8Array = new Uint8Array(arrayBuffer);

  for (let i = 0; i < byteString.length; i++) {
    uint8Array[i] = byteString.charCodeAt(i);
  }

  const blob = new Blob([uint8Array], { type: fileType });
  return new File([blob], fileName, { type: fileType });
}

export const goToFile = (link) => {
  if (!link) {
    console.error("No link provided to goToFile.");
    return;
  }

  try {
    new URL(link);
  } catch (error) {
    link = `https://${link}`;
  }

  window.open(link, "_blank", "noopener,noreferrer");
};

export const sanitizeInputValue = (value) => {
  const strValue = value == null ? "" : String(value);
  const cleanInput = DOMPurify.sanitize(strValue);
  return cleanInput;
};

export const hasAnyValue = (obj) =>
  Object.values(obj).some((val) => val !== undefined && val !== null);

export function buildQueryParams(params) {
  return Object.entries(params)
    .filter(
      ([key, value]) => value !== undefined && value !== null && value !== ""
    ) // Remove undefined, null, and empty string values
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .join("&");
}
